import { useLoginOrSignupPageData } from '#src/app/pages/loginOrSignup/pageContext';
import { useLoginSocialButtons, useSapCyclingProofExperiment } from '#src/app/pages/loginOrSignup/shared/hooks';
import { useTrackExperimentExposureOnMount } from '#src/app/shared/hooks/tracking';

type Result = ModelHookResult<{
	showSocialButtons: boolean;
	socialButtonsFirst: boolean;
	sapCyclingProofTreatment: boolean;
}>;

export function useEmailStep(): Result {
	const {
		data: { buttons },
	} = useLoginSocialButtons();
	const { data: pageData } = useLoginOrSignupPageData();
	const {
		data: { isTreatment },
	} = useSapCyclingProofExperiment();

	const experiment = pageData.experiments.loginSocialButtonsFirstExperiment;
	useTrackExperimentExposureOnMount(experiment);

	return {
		data: {
			showSocialButtons: !!buttons.length,
			// the V3d treatment forces social-first; control keeps the live social-first experiment
			socialButtonsFirst: isTreatment || experiment.variation === 'variant',
			sapCyclingProofTreatment: isTreatment,
		},
	};
}
